import { useState } from 'react';
import { useLookups, useMe } from '../lib/session.ts';
import { Button, Dialog, Field } from './ui.tsx';

/** A download button for a per-office Excel file: pick the office, then download. */
export function OfficeExport({ label, title, note, href }: { label: string; title: string; note?: string; href: (officeId: string) => string }) {
  const me = useMe().data!;
  const offices = useLookups().data?.offices ?? [];
  const [open, setOpen] = useState(false);
  const [officeId, setOfficeId] = useState(me.employee?.officeId ?? '');
  const chosen = officeId || offices[0]?.id || '';
  return (
    <>
      <Button icon="download" onClick={() => setOpen(true)}>
        {label}
      </Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        eyebrow="Excel"
        title={title}
        width={440}
        footer={
          <>
            <Button variant="ghost" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button
              variant="primary"
              icon="download"
              disabled={!chosen}
              onClick={() => {
                window.location.assign(href(chosen));
                setOpen(false);
              }}
            >
              Download
            </Button>
          </>
        }
      >
        <div className="stack">
          <Field label="Office">
            {(p) => (
              <select {...p} className="select" value={chosen} onChange={(e) => setOfficeId(e.target.value)}>
                {offices.map((o) => (
                  <option key={o.id} value={o.id}>
                    {o.name}
                  </option>
                ))}
              </select>
            )}
          </Field>
          {note ? <p className="faint" style={{ fontSize: 'var(--step--1)' }}>{note}</p> : null}
        </div>
      </Dialog>
    </>
  );
}
